import React, { Component } from "react"
import { isMobile } from "react-device-detect"
import { UspBannerInnerBlock } from "./UspBannerInnerBlock"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export class UspBannerBlock extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
    }

    this.showHideContent = this.props.showHideContent.bind(this)
  }

  render() {
    const mobileInfobarStyle = isMobile ? { height: 0, overflow: "hidden", transition: "height 0.3s ease" } : {}
    return (
      <div
        className={`departure-info__essentials__infobar ${SelectionFactoryHelper.getFromSelectionFactory(this.state.block.theme)} ${
          isMobile ? "foldable" : ""
        }`}
      >
        <h5 onClick={isMobile ? (e) => this.showHideContent(e, ".grid") : undefined}>
          {this.state.block.header && this.state.block.header.replace(/<\/?[^>]+(>|$)/g, "")}
        </h5>
        <div className="grid" style={mobileInfobarStyle}>
          {this.state.block.itemBlocks.map((block, i) => {
            if (block.__type__ === "UspBannerItemBlock") {
              return <UspBannerInnerBlock key={i} block={block} length={this.state.block.itemBlocks.length} />
            }
          })}
        </div>
      </div>
    )
  }
}
